import * as React from "react";
import { Button, Grid } from "semantic-ui-react";

import { FileAnswer } from "../../questionnaires/model";

interface Props {
    fileApiUrl: string;
    documents: FileAnswer[];
}

export const SharedDocuments: React.FunctionComponent<Props> = (props: Props) => {

    const documents = props.documents ?? [];

    return (
        <>
            {documents && documents.map((document, index) =>
                (<React.Fragment key={index}>
                    <Grid>
                        <Grid.Column>
                            <a
                                key={index}
                                href={`${props.fileApiUrl}/${document.blobId}?fileName=${document.fileName}`}
                            >
                                <Button content={document.fileName} type="button" />
                            </a>
                        </Grid.Column>
                    </Grid>
                </React.Fragment>))
            }
        </>
    );
};
